import { render, staticRenderFns } from "./offering-row.vue?vue&type=template&id=5811ef2c&"
import script from "./offering-row.vue?vue&type=script&lang=js&"
export * from "./offering-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports